/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_StrengthsInputs */

const en_directory_agent_readiness_strengths = /** @type {(inputs: Directory_Agent_Readiness_StrengthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What helps agents`)
};

const zh_directory_agent_readiness_strengths = /** @type {(inputs: Directory_Agent_Readiness_StrengthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对 Agent 有帮助的部分`)
};

/**
* | output |
* | --- |
* | "What helps agents" |
*
* @param {Directory_Agent_Readiness_StrengthsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_strengths = /** @type {((inputs?: Directory_Agent_Readiness_StrengthsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_StrengthsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_strengths(inputs)
	return zh_directory_agent_readiness_strengths(inputs)
});
export { directory_agent_readiness_strengths as "directory.agent_readiness.strengths" }